import EditProfile from './component';

export default EditProfile;
